// Chamado aberto pelo APP DE CAMPO (pwa-campo › Chamados): o que o administrativo
// precisa ver dele.
//
// Por que existe (07/10/2026): no celular a pessoa escreve o veículo ou o
// equipamento no campo "Equipamento / item" ("Strada freedom", "Carro strada",
// "GNSS CHC i73"), e o app grava isso em `dados.equipamento`. O quadro do
// administrativo só sabia mostrar os campos do formulário do próprio ERP
// (Local, Problema) — o veículo chegava ao banco e não aparecia em lugar nenhum.
// Junto ficavam invisíveis a categoria escolhida no app (avaria × manutenção) e
// o ponto do GPS no momento da abertura (onde o veículo/equipamento estava).

export const CATEGORIA_CHAMADO_CAMPO: Record<string, string> = {
  avaria: '🔧 Avaria de equipamento',
  manutencao: '🧰 Manutenção / estrutura',
  suprimentos: '📦 Material / suprimentos',
};

/** O veículo/equipamento que a pessoa escreveu no app, ou null. */
export function itemDoChamado(dados: any): string | null {
  const v = typeof dados?.equipamento === 'string' ? dados.equipamento.trim() : '';
  return v || null;
}

/** Linhas do quadro de dados do chamado que vêm do app de campo. */
export function linhasDoChamadoDeCampo(dados: any): Array<[string, string]> {
  const linhas: Array<[string, string]> = [];
  if (!dados || typeof dados !== 'object') return linhas;
  if (dados.origem === 'pwa_campo') {
    const cat = CATEGORIA_CHAMADO_CAMPO[dados.categoria] || null;
    linhas.push(['📱 Aberto pelo app de campo', cat || 'sim']);
  }
  const item = itemDoChamado(dados);
  if (item) linhas.push(['🚙 Veículo / equipamento', item]);
  return linhas;
}

/** Link do mapa para o ponto do GPS gravado na abertura, ou null se não há ponto válido. */
export function linkDoMapa(gps: any): { url: string; precisao: string | null } | null {
  const lat = Number(gps?.lat);
  const lon = Number(gps?.lon);
  if (gps?.lat == null || gps?.lon == null || !Number.isFinite(lat) || !Number.isFinite(lon)) return null;
  if (Math.abs(lat) > 90 || Math.abs(lon) > 180 || (lat === 0 && lon === 0)) return null;
  const acc = Number(gps?.accuracy);
  return {
    url: `https://www.google.com/maps?q=${lat.toFixed(6)},${lon.toFixed(6)}`,
    precisao: gps?.accuracy != null && Number.isFinite(acc) && acc > 0 ? `±${Math.round(acc)} m` : null,
  };
}
